import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModificationAlertService {

  constructor() { }

  public statusAlert = new Subject<any>();
  public statusAlertSecondary = new Subject<any>();

  public validator = new Subject<any>();

  public setStatusAlert(params) {
    this.statusAlert.next(params);
  }

  public setStatusAlertSecondary(params) {
    this.statusAlertSecondary.next(params);
  }

  public getStatusAlert(): Observable<any> {
    return this.statusAlert.asObservable();
  }

  public getStatusAlertSecondary(): Observable<any> {
    return this.statusAlertSecondary.asObservable();
  }

  public setValidator(params) {
    this.validator.next(params);
  }

  public getValidator(): Observable<any> {
    return this.validator.asObservable();
  }

}
